import { getResidentialGooglePredictions } from 'utils/google-maps';
import { processPredictions } from './utils';
import { SearchStrategyProps, SearchResult } from './SearchStrategy';
import { CountryCode } from 'types/countries';
import { BaseSearchStrategy } from './BaseSearchStrategy';
import SearchPrediction from 'data/search-predictions';
import { ZOOCASA_TENANT_ID } from 'tenants';

export class DefaultSearchStrategy extends BaseSearchStrategy {
  /**
   * Process search results for the default search strategy
   */
  protected async processSearchResults(goSearchPredictions: SearchPrediction[], props: SearchStrategyProps): Promise<SearchResult> {
    const { queryString, useUsListings = false, siteLocation, themeName } = props;

    // Get predictions from Google Maps
    const googleSearchPredictions = await getResidentialGooglePredictions(
      queryString,
      (useUsListings && themeName === ZOOCASA_TENANT_ID),
      siteLocation as CountryCode
    );

    // Process and combine predictions
    const finalPredictions = processPredictions(goSearchPredictions, googleSearchPredictions);

    return {
      searchPredictions: finalPredictions,
      searchAgentPredictions: [],
    };
  }
}